module.exports = __webpack_public_path__ + "static/img/shc.9bf51c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/shc.jpg
// module id = TMDF
// module chunks = 0